var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { StyledModal as Modal } from './styled';
import React from 'react';
import { CloseOutline } from '../Icon';
import confirm, { destroyFns } from './ModalConfirm/confirm';
import { colors } from '../../theme/colors';
Modal.defaultProps = {
    cancelText: 'Отмена',
    closeIcon: React.createElement(CloseOutline, null),
    maskStyle: {
        backgroundColor: colors.gray9 + "59"
    }
};
Modal.confirm = function confirmFn(props) {
    return confirm(props);
};
Modal.error = function errorFn(props) {
    return confirm(__assign(__assign({}, props), { modalType: 'error' }));
};
Modal.success = function successFn(props) {
    return confirm(__assign(__assign({}, props), { modalType: 'success' }));
};
Modal.info = function infoFn(props) {
    return confirm(__assign(__assign({}, props), { modalType: 'info' }));
};
Modal.destroyAll = function destroyAllFn() {
    while (destroyFns.length) {
        var close_1 = destroyFns.pop();
        if (close_1) {
            close_1();
        }
    }
};
export default Modal;
//# sourceMappingURL=Modal.js.map